import { attempt } from "./function.utils";
import { isDefined } from "./helper.utils";

export function parseIntSafe(value: string | undefined): number | undefined;
export function parseIntSafe(
    value: string | undefined,
    defaultValue: number
): number;
export function parseIntSafe(value: string | undefined, defaultValue?: number) {
    if (!isDefined(value)) return defaultValue;

    const parsed = parseInt(value, 10);

    return Number.isNaN(parsed) ? defaultValue : parsed;
}

export function parseFloatSafe(value?: any): number | undefined;
export function parseFloatSafe(value: any, defaultValue: number): number;
export function parseFloatSafe(value?: any, defaultValue?: number) {
    if (!isDefined(value)) return defaultValue;

    const result = attempt(
        () => parseFloat(value.toString().replace(",", ".")),
        defaultValue
    );

    return Number.isNaN(result) ? defaultValue : result;
}
